import React from 'react';
import { PRODUCT_NAME, WHATSAPP_URL } from '../data/content';
const links = [{
  label: 'Hablar con un asesor por WhatsApp',
  href: WHATSAPP_URL
}, {
  label: 'Soporte por mail',
  href: 'mailto:hola@elmetododelfutbol.com'
}, {
  label: 'Instagram',
  href: 'https://instagram.com'
}, {
  label: 'Sitio oficial',
  href: 'https://el-metodo-del-futbol.impultienda.ar'
}];
export function Footer() {
  return <footer className="bg-ink px-5 py-14 text-white lg:px-8" data-id="element-121" data-mp="3uesclnpm7fkq">
      <div className="mx-auto max-w-6xl" data-id="element-122" data-mp="3ud7czjog16g0">
        <div className="grid gap-8 sm:grid-cols-[1.4fr_1fr]" data-id="element-123" data-mp="37o56rpk5rbs">
          <div data-id="element-124" data-mp="3lec9wggp4cgx">
            <p className="display text-2xl" data-id="element-125" data-mp="3leviv7odbqit">{PRODUCT_NAME}</p>
            <p className="mt-3 max-w-md text-sm leading-relaxed text-white/60" data-id="element-126" data-mp="3lggez1qbzhis">
              El sistema completo para profes de fútbol. Porque dirigir no debería
              costarte todas las noches de la semana.
            </p>
          </div>
          <ul className="flex flex-col gap-3 text-sm sm:items-end" data-id="element-127" data-mp="2eyjprl0ekyu3">
            {links.map(link => <li key={link.label} data-id="element-128" data-mp="3lalfndz543tf">
                <a href={link.href} target="_blank" rel="noopener noreferrer" className="text-white/70 transition-colors duration-150 ease-out hover:text-grass focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-grass" data-id="element-129" data-mp="3lbmttrbgd6fd">
                  {link.label}
                </a>
              </li>)}
          </ul>
        </div>
        <p className="mt-10 border-t border-white/10 pt-6 text-[11px] font-bold uppercase tracking-[0.2em] text-white/40" data-id="element-130" data-mp="32vyphf92q4z">
          © {PRODUCT_NAME} 2026 — Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}